import { StyleSheet } from 'react-native';
import { CARD_WIDTH, CARD_MARGIN } from '../components/consts';
import { theme } from '../theme';
export const styles = StyleSheet.create({
    container: {
        marginTop: 20,
    },
    card: {
        width: CARD_WIDTH,
        marginLeft: CARD_MARGIN,
        marginTop: CARD_MARGIN,
        marginBottom: CARD_MARGIN,
    },
    labelText: {
        marginTop: 6,
        fontWeight: 'bold',
    },
    radioItemText: {
        marginTop: 8,
    },
    headerText: {
        marginTop: 10,
        marginBottom: 10,
        fontWeight: 'bold',
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
    },
    pointerEventsNone: { pointerEvents: 'none' },
    pointerEventsAuto: { pointerEvents: 'auto' },
    foodCategoryText: {
        marginTop: 8,
        fontWeight: 'bold',
    },
    checkboxContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    checkboxWrapper: {
        flexBasis: '30%',
        maxWidth: 180,
    },
    buttonView: {
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        padding: 20,
    },
    buttonStyle: {
        width: 160,
    },
    mealsFieldsContainer: {
        marginLeft: -10,
    },
    errorText: {
        marginLeft: 10,
        fontSize: 12,
        color: theme.colors.dangerText,
    },
    errorSnackbar: {
        backgroundColor: theme.colors.errorBanner,
    },
    snackbarContent: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    snackbarText: {
        color: theme.colors.surfaceElevated,
    },
    snackbarLink: {
        textDecorationLine: 'underline',
        marginTop: 4,
    },
    requiredField: {
        marginLeft: CARD_MARGIN,
    },
});
